<script>
import {checkWxSyncStatus, getSyncLogDetails, getTimerSettingList, setSystemSettingInfo, syncWxAccountOnce} from "@/api/setting-api";
import {getListSync} from "@/api/log-api";

export default {
  name: "TimerSettingPage",
  data() {
    return {
      activeName: "first",
      form0: {
        time: '',
        originTime: '',
      },
      buttonLoading: false,

      lastSync: {
        result: '',
        time: '',
      },

      dialog: {
        show: false,
        historyTableData: [],
        ensureButtonLoading: false,
      },

      detailDialog: {
        show: false,
        loading: false,
        logId: 0,
        items: [],
        totals: 0,
        current: 1,
        size: 20,
      },

      form1: {
        dataSwitch: "",
        dataSaveDuration: '',
        dataSaveOptTime: '',
        dataBackupType: '',
        dataBackupDay: '',
        dataBackupTime: '',
      }
    }
  },

  mounted() {
    console.log("mounted")
    this.fetchLastSync()
    getTimerSettingList().then(({data}) => {
      if (data.code === 200) {
        data.data.forEach(item => {
          if (item.type === "SYNC_CONTACTS") {
            if (item.content === '') {
              this.form0.time = ''
              this.form0.originTime = ''
            } else {
              this.form0.time = Number.parseInt(item.content)
              this.form0.originTime = Number.parseInt(item.content)
            }
          } else if (item.type === "DATA_BACKUP") {
            let content = JSON.parse(item.content)
            const exec = content.exec
            const save = content.save
            const backup = content.backup

            this.form1.dataSwitch = item.state
            this.form1.dataSaveDuration = save
            this.form1.dataSaveOptTime = exec
            this.form1.dataBackupType = backup.type
            this.form1.dataBackupDay = backup.day ? backup.day : ""
            this.form1.dataBackupTime = exec
          }
        })
      }
    })
  },

  methods: {

    fetchLastSync() {
      checkWxSyncStatus().then(({data}) => {
        if (data.code === 200 && data.data) {
          this.lastSync.result = data.data.lastResult || ''
          this.lastSync.time = data.data.lastTime || ''
        }
      }).catch((err) => {
        console.log("checkWxSyncStatus err ", err)
      })
    },

    doSyncWechat() {
      this.buttonLoading = true
      this.dialog.show = false;
      syncWxAccountOnce().then(({data}) => {
        if (data.code === 200) {
          this.$message.success("同步完成，部门与员工数据已更新")
        } else {
          this.$message.error("同步失败：" + (data.msg || "未知错误"))
        }
      }).catch((err) => {
        this.$message.error("同步失败：" + this.httpErrMsg(err))
      }).finally(() => {
        this.buttonLoading = false
        this.fetchLastSync()
      })
    },


    doCancelDialog() {
      this.dialog.show = false
      this.buttonLoading = false
    },

    syncWxOnce() {
      this.dialog.show = true

      getListSync(1, 5).then(({data}) => {
        if (data.code === 200) {
          this.dialog.historyTableData = data.data.data
        }
      }).catch(() => {

      })
    },

    onForm0Commend() {
      console.log("onForm0Commend", this.form0.time)  // CHECK PASS

      let content = this.form0.time.toString()
      let valid = content !== "" ? "VALID" : "INVALID"
      const postData = {
        target: "TIMED_TASK",
        type: "SYNC_CONTACTS",
        content: content,
        state: valid
      }
      setSystemSettingInfo(postData).then(({data}) => {
        console.log("setSystemSettingInfo", data)
        if (data.code === 200) {
          this.$message.success('保存成功')
          this.form0.originTime = this.form0.time
        } else {
          this.$message.error('保存失败')
        }
      }).catch(() => {

        this.$message.error('保存失败')
      })
    },

    onForm1Comment() {
      this.$refs.form1.validate((res) => {
        if (res) {
          console.log("Check pass")
          this.doForm1Save(this.form1)
        } else {
          console.log("Check false")
        }
      })
    },
    doForm1Save(form1) {
      let valid = form1.dataSwitch
      let exec = Math.min(form1.dataBackupTime, form1.dataSaveOptTime)
      let save = form1.dataSaveDuration
      let backup = {type: form1.dataBackupType}
      if (form1.dataBackupType === 'week') {
        backup.day = form1.dataBackupDay
      }
      let contentObj = {
        exec: exec,
        save: save,
        backup: backup
      }
      let content = JSON.stringify(contentObj)
      console.log("content", content)
      const postData = {
        target: "TIMED_TASK",
        type: "DATA_BACKUP",
        content: content,
        state: valid
      }
      setSystemSettingInfo(postData).then(({data}) => {
        console.log("setSystemSettingInfo", data)
        if (data.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      }).catch(() => {
        this.$message.error('保存失败')
      })
    },

    viewSyncDetail(row) {
      this.detailDialog.logId = row.id
      this.detailDialog.current = 1
      this.detailDialog.show = true
      this.loadSyncDetail()
    },

    loadSyncDetail() {
      this.detailDialog.loading = true
      getSyncLogDetails(this.detailDialog.logId, this.detailDialog.current, this.detailDialog.size).then(({data}) => {
        if (data.code === 200) {
          this.detailDialog.items = data.data.data || []
          this.detailDialog.totals = data.data.totals || 0
        } else {
          this.$message.error('查询明细失败')
        }
      }).catch(() => {
        this.$message.error('查询明细失败')
      }).finally(() => {
        this.detailDialog.loading = false
      })
    },

    prettyJson(body) {
      try {
        return JSON.stringify(JSON.parse(body), null, 2)
      } catch (e) {
        return body
      }
    }

  },
  filters: {
    formatTime(time) {
      const date = new Date(time);
      const year = date.getFullYear().toString().slice(-2);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    formatResult(result) {
      switch (result) {
        case "SUCCESS":
          return "执行成功"
        case "RUNNING":
          return "执行中"
        default:
          return "失败"
      }
    },
    formatOperator(operator) {
      if (!operator) return '-'
      if (operator === 'TIMED_TASK') return '定时任务'
      if (operator.startsWith('MANAGE:')) return '后台账号#' + operator.slice(7)
      return operator
    },
  },
}
</script>

<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="企业微信" name="first">
        <el-form ref="form0" :model="form0" label-width="80px" label-position="left">
          <el-form-item label="定时设置" prop="time">
            <el-select v-model="form0.time" placeholder="请选择同步时间">
              <el-option label="关闭" value=""></el-option>
              <el-option v-for="hour in 24" :key="hour - 1" :label="`每天${hour - 1}时`" :value="hour - 1"></el-option>
            </el-select>

            <el-button type="primary" @click="syncWxOnce" style="margin-left: 20px" :loading="buttonLoading">
              手动同步一次
            </el-button>
          </el-form-item>
          <el-alert v-if="form0.originTime !== ''" style="margin-bottom: 20px; width: 320px"
                    :title="`每天${form0.originTime}点执行企业通讯录同步任务`" type="info" :closable="false"></el-alert>
          <el-alert v-else style="margin-bottom: 20px; width: 320px" :title="`执行企业通讯录同步定时任务已关闭`"
                    type="info" :closable="false"></el-alert>
          <el-alert v-if="lastSync.result && lastSync.result !== 'NONE'"
                    :style="`margin-bottom: 20px; width: 320px`"
                    :title="`上次同步：${lastSync.time || '时间未知'}（${lastSync.result === 'SUCCESS' ? '成功' : '失败'}）`"
                    :type="lastSync.result === 'SUCCESS' ? 'success' : 'error'" :closable="false"></el-alert>
          <el-form-item>
            <el-button type="primary" @click="onForm0Commend">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="数据备份" name="second">
        <el-form ref="form1" :model="form1" label-width="80px">
          <h4>数据开关</h4>
          <el-form-item label="开关设置" prop="dataSwitch" required>
            <el-radio-group v-model="form1.dataSwitch">
              <el-radio label="VALID">开启</el-radio>
              <el-radio label="INVALID">关闭</el-radio>
            </el-radio-group>
          </el-form-item>


          <h3>数据保存</h3>
          <el-form-item label="有效时间" prop="dataSaveDuration" :required="form1.dataSwitch === 'VALID'">
            <el-select v-model="form1.dataSaveDuration" placeholder="请选择数据保存有效时间" :disabled="form1.dataSwitch === 'INVALID'">
              <el-option label="1年" value="1"></el-option>
              <el-option label="2年" value="2"></el-option>
              <el-option label="3年" value="3"></el-option>
              <el-option label="4年" value="4"></el-option>
              <el-option label="5年" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行时间" prop="dataSaveOptTime" :required="form1.dataSwitch === 'VALID'">
            <el-select v-model="form1.dataSaveOptTime" placeholder="请选择数据保存执行时间" :disabled="form1.dataSwitch === 'INVALID'">
              <el-option v-for="item in 24" :key="item" :label="`${item - 1}时`" :value="item - 1"></el-option>
            </el-select>
          </el-form-item>
          <h3>数据备份</h3>

          <el-form-item label="备份频率" prop="dataBackupType" :required="form1.dataSwitch === 'VALID'">
            <el-select v-model="form1.dataBackupType" placeholder="请选择数据备份频率" :disabled="form1.dataSwitch === 'INVALID'">
              <el-option label="每天" value="day"></el-option>
              <el-option label="每周" value="week"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备份日期" prop="dataBackupDay" v-if="form1.dataBackupType === 'week'" :required="form1.dataBackupType === 'week' && form1.dataSwitch === 'VALID' ">
            <el-select v-model="form1.dataBackupDay" placeholder="请选择数据备份日期" :disabled="form1.dataSwitch === 'INVALID'">
              <el-option v-for="item in 7" :key="item" :label="`星期 ${item}`" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备份时间" prop="dataBackupTime" :required="form1.dataSwitch === 'VALID'">
            <el-select v-model="form1.dataBackupTime" placeholder="请选择数据备份时间" :disabled="form1.dataSwitch === 'INVALID'">
              <el-option v-for="item in 24" :key="item" :label="`${item - 1}时`" :value="item - 1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onForm1Comment">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :visible.sync="dialog.show" center title="手动执行">
      <el-table :data="dialog.historyTableData" border>
        <el-table-column property="timedHour" label="执行方式" width="110">
          <template v-slot="scope">
            <el-tag v-if="scope.row.timedHour === '-1'">手动执行</el-tag>
            <el-tag v-else>定时任务执行</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作人" width="120">
          <template v-slot="scope">
            {{ scope.row.operator | formatOperator }}
          </template>
        </el-table-column>
        <el-table-column property="beginTime" label="开始时间" width="150">
          <template v-slot="scope">
            {{ scope.row.beginTime | formatTime }}
          </template>
        </el-table-column>
        <el-table-column property="endTime" label="结束时间" width="150">
          <template v-slot="scope">
            {{ scope.row.endTime | formatTime }}
          </template>
        </el-table-column>
        <el-table-column property="execResult" label="执行结果" width="90">
          <template v-slot="scope">
            {{ scope.row.execResult | formatResult }}
          </template>
        </el-table-column>
        <el-table-column property="execMsg" label="结果详情" show-overflow-tooltip>
          <template v-slot="scope">
            {{ scope.row.execMsg || '-' }}
          </template>
        </el-table-column>
        <el-table-column property="requestParams" label="请求参数" width="140" show-overflow-tooltip>
          <template v-slot="scope">
            {{ scope.row.requestParams || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template v-slot="scope">
            <el-button type="text" size="mini" @click="viewSyncDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doCancelDialog">取 消</el-button>
        <el-button type="primary" @click="doSyncWechat">手动执行</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="detailDialog.show" title="企微接口调用明细" width="860px" append-to-body top="5vh">
      <div v-loading="detailDialog.loading">
        <el-empty v-if="!detailDialog.loading && detailDialog.items.length === 0" description="本次同步无接口调用明细"></el-empty>
        <div v-for="item in detailDialog.items" :key="item.id" class="detail-item">
          <div class="detail-head">
            <el-tag size="small" type="info">{{ item.api }}</el-tag>
            <el-tag size="small" :type="item.errcode === 0 ? 'success' : 'danger'">
              errcode: {{ item.errcode }}
            </el-tag>
            <span class="detail-params">参数：{{ item.requestParams || '-' }}</span>
            <span class="detail-time">{{ item.createdAt }}</span>
          </div>
          <pre class="detail-body">{{ prettyJson(item.responseBody) }}</pre>
        </div>
        <el-pagination v-if="detailDialog.totals > detailDialog.size" style="text-align: center; margin-top: 10px"
                       layout="prev, pager, next" :total="detailDialog.totals" :page-size="detailDialog.size"
                       :current-page.sync="detailDialog.current" @current-change="loadSyncDetail">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">
.detail-item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 8px;

  .detail-head {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 6px;

    .detail-params {
      font-size: 12px;
      color: #606266;
    }

    .detail-time {
      margin-left: auto;
      font-size: 12px;
      color: #909399;
    }
  }

  .detail-body {
    margin: 0;
    max-height: 300px;
    overflow: auto;
    background: #f5f7fa;
    padding: 8px;
    font-size: 12px;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-all;
  }
}
</style>
